import { ApiService } from '../../services/api_service';
import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import { getCO2Scope3StructureAllgemein, getCO2Scope3StructureNachgelagert, getCO2Scope3StructureVorgelagert, filterCO2Scope3StructureNachgelagert } from './functions/getCO2Scope3Structure';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import assisStyle from './assistent/Assistent.less';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WSpinner } from '../../core/elements/spinner/WSpinner';
import { WFormFieldArchiv } from '../../core/forms/WFormFramework';
import { renderText } from './assistent/assistent_helpers';
import { WFormFieldSelectOptAsSlider } from '../../core/forms/fields/WFormFieldSelectOptAsSlider';

interface DateneingabeCO2Scope3AuswahlProps extends React.ClassAttributes<any> {
    data: any;
    standortSelected: any;
    jahrFix?: number;
    hideJahr?: boolean;
    showDetailierteErfassung?: boolean;
    showHelpIcon?: boolean;
    noTitle?: boolean;
    onClose?: () => void;
}

interface DateneingabeCO2Scope3AuswahlState {
    jahr: number;
    jahrMax: number;
    jahrMin: number;
    auswahlData: Array<any>;
    showSpinner: boolean;
    dokument: Array<any>;
}

export class DateneingabeCO2Scope3Auswahl extends React.Component<DateneingabeCO2Scope3AuswahlProps, DateneingabeCO2Scope3AuswahlState> {

    constructor(props: any) {
        super(props);
        const jahr_context = this.contextService.get('jahr_co2_scope3');
        const startjahr: number = ((this.props.data[IDs.ENT_KONFIGURATION] || [])
            .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear() - 1;
        const jahrMin: number = +startjahr > 1900 ? startjahr : 2010;
        const auswahlData: Array<any> = [];
        if (this.props.data[IDs.ENT_CO2_SCOPE3_AUSWAHL]) {
            this.props.data[IDs.ENT_CO2_SCOPE3_AUSWAHL].forEach((item: any) => auswahlData.push({ ...item }));
        }
        this.state = {
            jahr: this.props.jahrFix || jahr_context || jahrMax,
            jahrMax,
            jahrMin,
            auswahlData: auswahlData,
            showSpinner: false,
            dokument: []
        };
        this.copyVorjahr = this.copyVorjahr.bind(this);
        this.getScrollTop = this.getScrollTop.bind(this);
        this.setScrollTop = this.setScrollTop.bind(this);
    }

    private saveHandle = -1;
    private domId = 'DateneingabeCO2Scope3Auswahl';

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.checkDokumentRow();
    }

    checkDokumentRow() {
        const docuRow = this.props.data[IDs.ENT_CO2_SCOPE3_AUSWAHL].find((r: any) =>
            r.jahr === this.state.jahr && (r.standort_tid_orig || r.standort_tid) === this.props.standortSelected.tid && r.name === 'dokument'
        );
        if (!docuRow) {
            this.setState({ showSpinner: true }, () => {
                const docuNew = {
                    name: 'dokument',
                    jahr: this.state.jahr,
                    standort_tid: this.props.standortSelected.tid
                };
                this.dataService.saveData(IDs.ENT_CO2_SCOPE3_AUSWAHL, docuNew, null, null, (suc: boolean, saveTid: number) => {
                    console.log(saveTid, docuNew);
                    this.triggerService.fire('reload', IDs.ENT_CO2_SCOPE3_AUSWAHL, () => {
                        this.setState({ showSpinner: false });
                    });
                }, IDs.MOD_ETOOL);
            });
        } else {
            this.loadDokumente(docuRow);
        }
    }

    loadDokumente(docuRow: any) {
        const galKey = `${IDs.ENT_CO2_SCOPE3_AUSWAHL}_${docuRow.tid}`;
        this.dataService.loadData(IDs.ENT_GALLERY, { parent_entity: galKey }, {}, (res: any) => {
            if (Array.isArray(res[IDs.ENT_GALLERY])) {
                this.setState({ dokument: res[IDs.ENT_GALLERY] });
            }
        }, IDs.MOD_ETOOL);
    }

    onChangeAuswahl(key: string, auswahl: boolean): void {
        const auswahlData = this.state.auswahlData;
        const row = auswahlData.find((r: any) =>
            r.jahr === this.state.jahr
            && (r.standort_tid_orig === this.props.standortSelected.tid || r.standort_tid === this.props.standortSelected.tid)
            && r.name === key
        );
        if (!row) {
            auswahlData.push({
                tid: 0,
                standort_tid: this.props.standortSelected.tid,
                standort_tid_orig: this.props.standortSelected.tid,
                jahr: this.state.jahr,
                name: key,
                auswahl: auswahl ? 1 : 0,
                hinweis: ''
            });
        } else {
            row.auswahl = auswahl ? 1 : 0;
        }
        this.setState({ auswahlData }, this.saveDelayed);
    }

    onChangeHinweis(key: string, hinweis: string): void {
        const auswahlData = this.state.auswahlData;
        const row = auswahlData.find((r: any) =>
            r.jahr === this.state.jahr
            && (r.standort_tid_orig === this.props.standortSelected.tid || r.standort_tid === this.props.standortSelected.tid)
            && r.name === key
        );
        if (!row) {
            auswahlData.push({
                tid: 0,
                standort_tid: this.props.standortSelected.tid,
                standort_tid_orig: this.props.standortSelected.tid,
                jahr: this.state.jahr,
                name: key,
                auswahl: 0,
                hinweis
            });
        } else {
            row.hinweis = hinweis;
        }
        this.setState({ auswahlData }, this.saveDelayed);
    }

    saveDelayed(): void {
        const handle = window.setTimeout(() => {
            if (handle === this.saveHandle) {
                console.log('Save now!');
                this.saveNow(false);
            } else {
                console.log('Save discarded!');
            }
        }, 1000);
        this.saveHandle = handle;
        this.onDelayedSaving(true);
    }

    onDelayedSaving(isSaving: boolean) {
        const closeBtn = document.getElementsByClassName("ui-dialog-titlebar-close");
        if (closeBtn.length > 0) {
            isSaving ?
                closeBtn[0].setAttribute('disabled', 'disabled') :
                closeBtn[0].removeAttribute('disabled');

        }
    }

    saveNow(closeAfter: boolean): boolean {
        const saveList: Array<any> = [];
        const auswahlData = this.state.auswahlData;
        const auswahlDataLoaded = this.props.data[IDs.ENT_CO2_SCOPE3_AUSWAHL];
        auswahlData.forEach((row: any) => {
            const foundLoaded = auswahlDataLoaded.find((rl: any) =>
                rl.name === row.name
                && (rl.standort_tid_orig === row.standort_tid || rl.standort_tid_orig === row.standort_tid_orig)
                && rl.jahr === row.jahr
            );
            if (foundLoaded) {
                if (!closeAfter && row.jahr === 2014) {
                    console.log('Saving List Check: ', row, foundLoaded);
                }
                if (foundLoaded.hinweis !== row.hinweis || foundLoaded.auswahl !== row.auswahl) {
                    if (row.standort_tid_orig) {
                        row.standort_tid = row.standort_tid_orig;
                    }
                    saveList.push(row);
                }
            } else {
                saveList.push(row);
            }
        });
        if (saveList.length > 0) {
            this.setState({ showSpinner: true }, () => {
                console.log('Saving List: ', saveList);
                this.dataService.saveDataList(IDs.ENT_CO2_SCOPE3_AUSWAHL, saveList, () => {
                    const scrollTop = this.getScrollTop();
                    this.triggerService.fire('reload', IDs.ENT_CO2_SCOPE3_AUSWAHL, () => {
                        this.onDelayedSaving(false);
                        this.setScrollTop(scrollTop);
                        this.setState({ showSpinner: false });
                    });
                    if (closeAfter) {
                        if (this.props.onClose) {
                            alert('Die Auswahl des Vorjahres wurde übernommen! Der Auswahl-Dialog wird geschlossen!');
                            this.props.onClose();
                        } else {
                            alert('Die Auswahl des Vorjahres wurde übernommen!');
                        }
                    }
                }, IDs.MOD_ETOOL);
            });
            return true;
        } else {
            return false;
        }
    }

    checkNow(auswahlData: Array<any>): boolean {
        const saveList: Array<any> = [];
        const auswahlDataLoaded = this.props.data[IDs.ENT_CO2_SCOPE3_AUSWAHL];
        auswahlData.forEach((row: any) => {
            const foundLoaded = auswahlDataLoaded.find((rl: any) =>
                rl.name === row.name
                && (rl.standort_tid_orig === row.standort_tid || rl.standort_tid_orig === row.standort_tid_orig)
                && rl.jahr === row.jahr
            );
            if (foundLoaded) {
                if (foundLoaded.hinweis !== row.hinweis || foundLoaded.auswahl !== row.auswahl) {
                    if (row.standort_tid_orig) {
                        row.standort_tid = row.standort_tid_orig;
                    }
                    saveList.push(row);
                }
            } else {
                saveList.push(row);
            }
        });
        if (saveList.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    updateTids(): void {
        const auswahlData = this.state.auswahlData;
        const auswahlDataLoaded = this.props.data[IDs.ENT_CO2_SCOPE3_AUSWAHL];
        // console.log('updateTids 1: ', auswahlData);
        // console.log('updateTids 2: ', auswahlDataLoaded);
        let changed = false;
        auswahlData.forEach((row: any) => {
            if (row.tid === 0) {
                const foundLoaded = auswahlDataLoaded.find((rl: any) =>
                    rl.name === row.name && rl.standort_tid_orig === row.standort_tid && rl.jahr === row.jahr
                );
                if (foundLoaded) {
                    row.tid = foundLoaded.tid;
                    console.log('Updated TID: ', row, foundLoaded);
                    changed = true;
                }
            }
        });
        if (changed) {
            this.setState({ auswahlData });
        }
    }

    copyVorjahr(testOnly: boolean) {
        if (!testOnly && !window.confirm('Soll die aktuelle Auswahl durch die Auswahl des Vorjahres überschrieben werden?')) {
            return;
        }
        let auswahlData: Array<any> = [];
        if (testOnly) {
            this.state.auswahlData.forEach((item: any) => auswahlData.push({ ...item }));
        } else {
            auswahlData = this.state.auswahlData;
        }
        const auswahlLastYear = auswahlData.filter((r: any) =>
            r.jahr === (this.state.jahr - 1) && r.standort_tid_orig === this.props.standortSelected.tid
        );
        // console.log('Auswahl Vorjahr: ', auswahlLastYear);
        auswahlLastYear.forEach((item: any) => {
            // versuchen wir den aktuellen Eintrag zu finden
            const row = auswahlData.find((r: any) =>
                r.jahr === this.state.jahr && r.standort_tid_orig === this.props.standortSelected.tid && r.name === item.name
            );
            // console.log('Found: ', row);
            // Fallunterscheidung
            if ((!item.auswahl && !item.hinweis) && (!row || !row.auswahl)) {
                // Alles klar... brauchen nichts machen
            } else if (item.auswahl && row && row.auswahl) {
                // Alles klar... brauchen nichts machen
            } else if ((item.auswahl || item.hinweis) && !row) {
                // Row anlegen da Auswahl noch nicht existiert
                const row_copy = { ...item };
                row_copy.tid = 0;
                row_copy.jahr = this.state.jahr;
                row_copy.standort_tid = item.standort_tid_orig;
                auswahlData.push(row_copy);
            } else if (item.auswahl && row && !row.auswahl) {
                // Einfach aktivieren
                row.auswahl = 1;
            } else if (!item.auswahl && row && (row.auswahl || item.hinweis)) {
                // Einfach deaktivieren
                row.auswahl = 0;
                if (item.hinweis) {
                    row.hinweis = item.hinweis;
                }
            }
        });
        // Jetzt noch die Entfernen, die es im Vorjahr gar nicht gibt
        auswahlData
            .filter((r: any) => r.jahr === this.state.jahr && r.standort_tid_orig === this.props.standortSelected.tid)
            .forEach((item: any) => {
                // versuchen wir den aktuellen Eintrag zu finden
                // Achtung, hier ist die Bezeichnung umgedreht... item ist aus auswahlData und nicht das Vorjahr
                const row = auswahlData.find((r: any) =>
                    (r.jahr === this.state.jahr - 1) && r.standort_tid_orig === this.props.standortSelected.tid && r.name === item.name
                );
                if (!row) {
                    item.auswahl = 0;
                }
            });

        if (testOnly) {
            return this.checkNow(auswahlData);
        }
        this.setState({ auswahlData }, () => {
            // console.log(auswahlData);
            this.saveNow(true);
        });
    }

    render(): JSX.Element {
        this.updateTids();
        const hasVorjahr = this.state.auswahlData.some((r: any) =>
            r.jahr === (this.state.jahr - 1) && r.auswahl && r.standort_tid_orig === this.props.standortSelected.tid
        );
        const konfiguration: Array<any> = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const modul: string = (this.props.data || {}).MODUL_SELECTED || null;
        const bereichKey = this.apiService.getBereichKey();
        const structVorgelagert = getCO2Scope3StructureVorgelagert(bereichKey, modul);
        const structNachgelagert = filterCO2Scope3StructureNachgelagert(getCO2Scope3StructureNachgelagert(bereichKey, modul), konfiguration);
        let structAllgemein = getCO2Scope3StructureAllgemein();

        const hasEmittenten: boolean = (this.props.data || {})[IDs.ENT_CO2_SCOPE3_EMITTENTEN].find((emittent: any) =>
            emittent.jahr === this.state.jahr && (emittent.standort_tid_orig || emittent.standort_tid) === this.props.standortSelected.tid
        );
        if (!hasEmittenten) {
            structAllgemein = structAllgemein.filter((s: any) => s.key !== 'emittenten');
        }

        const checkVorjahr = this.copyVorjahr(true);

        return (
            <div
                id={this.domId}
                className={assisStyle.co2Scope3Auswahl}
            >
                {!this.props.noTitle &&
                    <div className={assisStyle.title}>
                        Scope 3 Kategorien: Prüfung der Wesentlichkeit
                    </div>
                }
                {renderText(`co2Scope3Auswahl`, this.props.data)}
                <button
                    className={assisStyle.btnCopyVorjahr}
                    style={{
                        margin: '10px 0',
                        ...(!hasVorjahr || !checkVorjahr ? { cursor: 'no-drop', backgroundColor: '#bbb' } : {})
                    }}
                    disabled={!hasVorjahr || !checkVorjahr}
                    onClick={() => this.copyVorjahr(false)}
                >
                    Auswahl aus Vorjahr übernehmen
                </button>
                <div className={assisStyle.title2}>
                    VORGELAGERTE EMISSIONEN
                </div>
                {structVorgelagert.map((item: any, idx: number) => this.renderRow(item, idx + 1000))}
                <div className={assisStyle.title2}>
                    NACHGELAGERTE EMISSIONEN
                </div>
                {structNachgelagert.map((item: any, idx: number) => this.renderRow(item, idx + 2000))}
                {structAllgemein.map((item: any, idx: number) => this.renderRow(item, idx + 3000))}
                <div className={assisStyle.title2}>
                    ZUSÄTZLICHE DATEI(EN) HINTERLEGEN
                </div>
                {this.renderDocument()}
                {this.state.showSpinner && <WSpinner label='Speichern' />}
            </div>
        );
    }

    renderRow(item: any, idx: number): JSX.Element {
        const row = this.state.auswahlData.find((r: any) =>
            r.jahr === this.state.jahr && (r.standort_tid_orig || r.standort_tid) === this.props.standortSelected.tid && r.name === item.key
        );
        const hinweis = row ? row.hinweis : '';
        const auswahl = (item.forced || item.ignore || (row && row.auswahl)) ? true : false;
        const options: Array<any> = [
            { label: 'Ja', value: 1 },
            { label: 'Nein', value: 2 }
        ];

        return (
            <div
                className={assisStyle.rowContainer}
                key={`co2Scope3Auswahl_row_${idx}`}
            >
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ fontWeight: 'bold' }}>
                        {item.name}
                    </div>
                    <WHelpIcon
                        data={this.props.data}
                        label={'Info "' + item.name + '"'}
                        helpKey={`co2_scope3_${item.key}`}
                        styleDivProps={{
                            marginLeft: 10
                        }}
                        styleProps={{
                            width: 16, height: 14, borderRadius: 10, backgroundColor: 'transparent', margin: 0
                        }}
                        style={'theme_small'}
                        type={'theme_info'}
                        customElement={'Info'}
                        useTheme
                        editBar
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'baseline', paddingLeft: 20 }}>
                    <WFormFieldSelectOptAsSlider
                        label={null}
                        value={options.find((o: any) => o.value === (auswahl ? 1 : 2))}
                        options={options}
                        horizontal
                        disabled={this.state.showSpinner || item.ignore || item.forced}
                        onChange={(opt: any) => {
                            const checked = opt.value === 1;
                            this.onChangeAuswahl(item.key, checked);
                        }}
                    />
                    {!auswahl &&
                        <input
                            style={{ flex: 1 }}
                            type='text'
                            onChange={(evt: any) => this.onChangeHinweis(item.key, evt.target.value)}
                            value={hinweis}
                        />
                    }
                    {item.ignore &&
                        <div style={{ fontStyle: 'italic' }}>
                            {item.ignoreHinweis || 'Wird automatisch berechnet'}
                        </div>
                    }
                </div>
            </div>
        );
    }

    renderDocument(): JSX.Element {
        const docuRow = this.props.data[IDs.ENT_CO2_SCOPE3_AUSWAHL].find((r: any) =>
            r.jahr === this.state.jahr && (r.standort_tid_orig || r.standort_tid) === this.props.standortSelected.tid && r.name === 'dokument'
        );
        if (!docuRow) {
            return null;
        }
        return <div
            className={assisStyle.rowContainer}
            key={`co2Scope3Auswahl_row_datei`}
        >
            <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 20, alignItems: 'baseline' }}>
                <WFormFieldArchiv
                    entity={IDs.ENT_CO2_SCOPE3_AUSWAHL}
                    label={null}
                    name='dokument'
                    value={docuRow.dokument || 0}
                    data={docuRow}
                    onGalleryChange={(action: string, row: any) => {
                        this.checkDokumentRow();
                    }}
                    format={'GALLERY'}
                    layout={'sidebysideComplexGreen'}
                    module={IDs.MOD_ETOOL}
                />
                {/* <div style={{ fontSize: 12, fontStyle: 'italic' }}>
                    {this.state.dokument.length > 0 ? `(${this.state.dokument.map((d: any) => d.name).join('; ')})` : ''}
                </div> */}
                <WHelpIcon
                    data={this.props.data}
                    label={'Info "Dokument"'}
                    helpKey={`pageScope3AuswahlDokument`}
                    styleDivProps={{
                        marginLeft: 10
                    }}
                    styleProps={{
                        width: 16, height: 14, borderRadius: 10, backgroundColor: 'transparent', margin: 0
                    }}
                    style={'theme_small'}
                    type={'theme_info'}
                    customElement={'Info'}
                    useTheme
                    editBar
                />
            </div>
        </div>;
    }

    getScrollTop() {
        const startElement = document.getElementById(this.domId);
        const targetElement = startElement.closest(`.${assisStyle.contentMain}`);
        if (targetElement) {
            return targetElement.scrollTop;
        }
    }

    setScrollTop(scrollTop: number) {
        const startElement = document.getElementById(this.domId);
        const targetElement = startElement.closest(`.${assisStyle.contentMain}`);
        if (targetElement) {
            targetElement.scrollBy(0, scrollTop);
        }
    }
}
